import { create } from 'zustand';

export interface DataInvalidationState {
    readonly userListsVersion: number;
    readonly organizationListsVersion: number;
    readonly policyBundlesVersion: number;
    readonly policyGrantsVersion: number;

    bumpUserListsVersion: () => void;
    bumpOrganizationListsVersion: () => void;
    bumpPolicyBundlesVersion: () => void;
    bumpPolicyGrantsVersion: () => void;
}

export const useDataInvalidationStore = create<DataInvalidationState>((set) => ({
    userListsVersion: 0,
    organizationListsVersion: 0,
    policyBundlesVersion: 0,
    policyGrantsVersion: 0,

    bumpUserListsVersion: () =>
        set((state: DataInvalidationState) => ({
            userListsVersion: state.userListsVersion + 1,
        })),
    bumpOrganizationListsVersion: () =>
        set((state: DataInvalidationState) => ({
            organizationListsVersion: state.organizationListsVersion + 1,
        })),
    bumpPolicyBundlesVersion: () =>
        set((state: DataInvalidationState) => ({
            policyBundlesVersion: state.policyBundlesVersion + 1,
        })),
    bumpPolicyGrantsVersion: () =>
        set((state: DataInvalidationState) => ({
            policyGrantsVersion: state.policyGrantsVersion + 1,
        })),
}));
